import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  Space,
  EditButton,
  DeleteButton,
  ShowButton,
} from "@pankod/refine-antd";
import { IHolidays } from "interfaces";

import dayjs from "dayjs";
import "dayjs/locale/pt-br";

dayjs.locale("pt-br");

export const HolidaysList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, sorter } = useTable<IHolidays>({
    initialSorter: [
      {
        field: "key",
        order: "asc",
      },
    ],
  });

  return (
    <List>
      <Table {...tableProps} rowKey="_id">
        <Table.Column
          dataIndex="description"
          key="description"
          title="Descrição"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("description", sorter)}
          sorter
        />
        <Table.Column
          dataIndex="date"
          key="date"
          title="Data"
          render={(value) => (
            <TextField
              value={value ? dayjs(value).format("DD/MM/YYYY") : "-"}
            />
          )}
          defaultSortOrder={getDefaultSortOrder("date", sorter)}
          sorter
        />
        <Table.Column<IHolidays>
          title="Ações"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record._id} />
              <ShowButton hideText size="small" recordItemId={record._id} />
              <DeleteButton hideText size="small" recordItemId={record._id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
